import { Input, ViewEncapsulation } from '@angular/core';
import { Component, ElementRef, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationUIComponent, HamburgerMenuService } from '@spartacus/storefront';
import { UigNavigationNode } from './uig-navigation-node-model';
import {WindowRef} from '@spartacus/core';

@Component({
    selector: 'app-uig-navigation-ui',
    templateUrl: './uig-navigation-ui.component.html',
    styleUrls: ['./uig-navigation-ui.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UigNavigationUiComponent extends NavigationUIComponent {

  @Input() node: UigNavigationNode;

  constructor(
    private childRouter: Router,
    private childRenderer: Renderer2,
    private childElemRef: ElementRef, hamburgerMenuService: HamburgerMenuService,
    winRef: WindowRef
  ) {
    super(childRouter, childRenderer, childElemRef, hamburgerMenuService, winRef);
  }

}
